import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "background-attachment"
    }}>{`background-attachment`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v3.0`}</p>
    <p>{`Sets the attachment for the background image. Only `}<inlineCode parentName="p">{`scroll`}</inlineCode>{` is supported (the default).`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/background-attachment"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/background-attachment`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      